module.exports = __webpack_public_path__ + "media/無聲的妳身後無聲的我.27054b17.mp3";